import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/doctorService";

export const fetchDoctors = createAsyncThunk("doctors/fetchAll", async (params) => {
  const res = await svc.getDoctors(params);
  return res.data;
});

export const createDoctorThunk = createAsyncThunk("doctors/create", async (data) => {
  const res = await svc.createDoctor(data);
  return res.data;
});

export const updateDoctorThunk = createAsyncThunk("doctors/update", async ({ id, data }) => {
  const res = await svc.updateDoctor(id, data);
  return res.data;
});

export const deleteDoctorThunk = createAsyncThunk("doctors/delete", async (id) => {
  await svc.deleteDoctor(id);
  return id;
});

const doctorSlice = createSlice({
  name: "doctors",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctors.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDoctors.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchDoctors.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createDoctorThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateDoctorThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((d) => d.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteDoctorThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((d) => d.id !== action.payload);
      });
  },
});

export default doctorSlice.reducer;
